export default __webpack_public_path__ + "static/rpacase2-24c893a48f270366d55ca3e0747afbd2.jpg";